export const bookingsColumnsStyles = {
  booking: { minWidth: 60, maxWidth: 70 },
  account: { minWidth: 130, maxWidth: 130, whiteSpace: 'normal' },
  brand: { minWidth: 130, maxWidth: 130, whiteSpace: 'normal' },
  campaign: { minWidth: 200, maxWidth: 200, whiteSpace: 'normal' },
  dates: { minWidth: 180, maxWidth: 180 },
  cost: { minWidth: 100, maxWidth: 110 },
  url: { maxWidth: 40, display: 'flex', justifyContent: 'flex-end' }
}

export const bookingsColumnsSchema = [
  {
    header: 'Booking',
    style: bookingsColumnsStyles.booking
  },
  {
    header: 'Account',
    style: bookingsColumnsStyles.account
  },
  {
    header: 'Brand',
    style: bookingsColumnsStyles.brand
  },
  {
    header: 'Campaign Name',
    style: bookingsColumnsStyles.campaign
  },
  {
    header: 'Dates',
    style: bookingsColumnsStyles.dates
  },
  {
    header: 'Cost',
    style: bookingsColumnsStyles.cost
  },
  {
    headerKey: 'url',
    style: bookingsColumnsStyles.url
  }
]
